module.exports = __webpack_public_path__ + "img/avatar5.9dbcf027.png";